import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { IAppConfigObject } from "appConfig.interfaces";

interface IArg {
  bookingId: string;
  config: IAppConfigObject;
}

export const cancelPaymentApi = createApi({
  reducerPath: "cancelPaymentApi",
  baseQuery: fetchBaseQuery({
    method: "GET",
    headers: {
      Accept: "application/json, text/plain",
      "Content-Type": "application/json;charset=UTF",
      "Access-Control-Allow-Credentials": "true",
      "Access-Control-Allow-Methods": "POST, GET",
      "Access-Control-Allow-Origin": "*",
    },
    prepareHeaders: (headers) => {
      headers.set("Content-Type", "application/json");
      return headers;
    },
  }),
  endpoints: (builder) => ({
    cancelPayment: builder.mutation<void, { arg: IArg }>({
      query: ({ arg }) => ({
        url: `${arg.config.FLIGHT_SEARCH_API_BASE_URL}/cancel/${arg.bookingId}?topLevelDomain=${arg.config.TOP_LEVEL_DOMAIN}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const { useCancelPaymentMutation } = cancelPaymentApi;
//
